<template>
    <div class="row container p-0 mb-4">
        <!-- <button @click="test">click</button> -->
        <div class="col-md-3">
            <div v-for="(step, index) in concat_data.sequence" :key="index">
                <div class="currentStep" @click="changeStep(step)">
                    <div class="stepBtn" :class="{active:currentStep == step}">{{index +1 }}</div>
                    <div class="stepBtn ml-2 fitContent" :class="{active:currentStep == step}">{{concat_data.steps[step].name}}</div>
                </div>
            </div>
        </div>

        <div class="col-md-9 formSection scrollable">
            <FormRenderer id="configurable" @changeControlPermission="asd" @changeSectionPermission="asdasd" :form-configuration="formConfiguration" v-model="formInputData" :current-step="currentStep" />
        </div>
        <!-- <div class="col-md-9 formSection scrollable" v-for="(form, index) in formConfigData" :key="index" v-if="form.stepId===currentStep">
            <div>
                <FormRenderer id="configurable" @test="asd" :form-configuration="formConfiguration" v-model="formInputData" :current-step="currentStep" />
                <div class="container-fluid" v-if="isTableAdded">
                    <div class="table-section">
                        <div class="tableConfigButtons">
                            <a @click="addTableConfig('Editable', currentStep)">Editable</a>
                            <a @click="addTableConfig('ReadOnly', currentStep)">Read-only</a>
                            <a @click="addTableConfig('Hidden', currentStep)">Hidden</a>
                        </div>
                        <table-editor :tableName="tableName" :tableData="tableData" :isBuildMode="false"></table-editor>  
                    </div>
                </div>
                <div class="container-fluid" v-if="isFileAdded">
                    <div class="table-section">
                        <div class="tableConfigButtons">
                            <a @click="addFileConfig('Editable', currentStep)">Editable</a>
                            <a @click="addFileConfig('ReadOnly', currentStep), btnDisabled=true">Read-only</a>
                            <a @click="addFileConfig('Hidden', currentStep)">Hidden</a>
                        </div>
                        <h2 id="fileInputHeader">Dosya</h2>
                        <div class="input-group w-100 mt-2">
                            <div class="custom-file">
                                <input v-if="!btnDisabled" type="file" class="custom-file-input" id="inputGroupFile02" @change="chooseFile($event)">
                                <input v-if="btnDisabled" type="file" class="custom-file-input" id="inputGroupFile02" disabled @change="chooseFile($event)">
                                <label class="custom-file-label mb-0" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">Seçili dosya yok</label>
                            </div>
                            
                        </div>  
                    </div>
                </div>
            </div>
            <div class="actionButtons" v-if="showActionButtons">
                <div class="separator mb-3">
                    <div class="line"></div>
                    <span>Configure Action</span>
                    <div class="line"></div>
                </div>
                <div class="row m-0 justify-content-end">
                    <div class="actionBtn">
                        <div class="sendBackHover">
                            <button :class="{active:buttonConfig[currentStep]['sendBack'] == 'hide'}" @click="changeButtonHoverConfig(currentStep,'sendBack','hide')">Hide</button>
                            <button :class="{active:buttonConfig[currentStep]['sendBack'] == 'show'}" @click="changeButtonHoverConfig(currentStep,'sendBack','show')">Show</button>
                        </div>
                        <button type="button" id="sendBack" class="btn btnLight m-1">Send back</button>
                    </div>
                    <div class="actionBtn">
                        <div class="sendBackHover">
                            <button :class="{active:buttonConfig[currentStep]['reject'] == 'hide'}" @click="changeButtonHoverConfig(currentStep,'reject','hide')">Hide</button>
                            <button :class="{active:buttonConfig[currentStep]['reject'] == 'show'}" @click="changeButtonHoverConfig(currentStep,'reject','show')">Show</button>
                        </div>
                        <button type="button" id="reject" class="btn m-1 btnLight">Reject</button>
                    </div>
                    <div class="actionBtn">
                        <button type="button" class="btn m-1 btn-primary px-4">Submit</button>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="pageFooter">
            <div class="container d-flex justify-content-end">
                <button class="btn btn-light mr-1 bg-white" @click="changePage('workflow')"><i class="far fa-arrow-left mr-2" style="font-weight:700;"></i>{{this.$ml.get('BACK')}}</button>
                <button class="btn btn-success" @click="sendFormData">{{this.$ml.get('CREATE_FORM')}}<i class="far fa-arrow-right ml-2" style="font-weight:700;"></i></button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'
import {v4 as uuidv4} from 'uuid';
import { FormRenderer } from 'v-form-builder'
import TableEditor from './tableEditorTest.vue'

export default {
    name: "FormGeneratorPermissions",
    components: {
        FormRenderer,
        TableEditor
    },
    props: ['formConfiguration', 'flow', 'formPermissions', 'buttonConfig', 'isUpdateMode', 'isTableAdded', 'tableName', 'tableData', 'tablePermissions', 'isFileAdded', 'filePermissions'],
    data () {
        return {
            concat_data:{},
            permissionObj:{},
            tempArray: [],
            currentStep: 'start',
            formInputData: null,
            formConfigData: [],
            showConfig: false,
            canEditableSection: true,
            showActionButtons:true,
            stepHoverConfig: {},
            stepTableConfig: {},
            stepFileConfig: {},
            btnDisabled: false,
            tempControlConfig: {},
            tempSectionConfig: {},
        }
    },
    computed:{
        ...mapState([
            'baseUrl'
        ]),
    },
    created() {
        this.$root.$refs.formGeneratorPermissions = this
    },
    watch: {

    },
    methods: {
        asd(a){
            if(a.config != undefined){
                if (this.tempControlConfig[a.id]) {
                    this.tempControlConfig[a.id][a.step] = a.config;
                } 
                else {
                    this.tempControlConfig[a.id] = {
                        [a.step]: a.config
                    };
                }
            }

        },

        asdasd(a) {
            if(a.config != undefined) {
                if (this.tempSectionConfig[a.id]) {
                    this.tempSectionConfig[a.id][a.step] = a.config;
                } 
                else {
                    this.tempSectionConfig[a.id] = {
                        [a.step]: a.config
                    };
                }
            }
            
        },

        changeStep(stepId) {
            this.currentStep = stepId
            let data = null
            for(let key in this.formConfiguration.controls) {
                for(let control in this.tempControlConfig){
                    if(key == control) {
                        this.formConfiguration.controls[key]['permission'] = this.tempControlConfig[control]
                    }
                }
            }

            for(let key in this.formConfiguration.sections) {
                for(let section in this.tempSectionConfig){
                    if(key == section) {
                        this.formConfiguration.sections[key]['permission'] = this.tempSectionConfig[section]
                    }
                }
            }
            this.$root.$refs.formGenerator.updateConfiguration(this.formConfiguration)

            // if(this.stepHoverConfig.hasOwnProperty(stepId)){
                
            //     data = this.stepHoverConfig[stepId]
            //     setTimeout(() => {
            //         this.addIdToSections(data);
            //     }, 0);
            // }
            // else{
            //     if(Object.keys(this.formPermissions).length!==0){
            //         for(let step in this.formPermissions){
            //             if(step === stepId) {
            //                 data = this.formPermissions[stepId]
            //                 setTimeout(() => {
            //                     this.addIdToSections(data, "update");
            //                 }, 0);
            //             }
            //         }
            //     }
            //     else {
            //         data = null
            //         setTimeout(() => {
            //             this.addIdToSections(data);
            //         }, 0);
            //     }
                
            // } 
            
            // setTimeout(() => {
            //     if(this.isTableAdded){
            //         this.addTableConfig('change', stepId);
            //     }
            //     if(this.isFileAdded){
            //         this.addFileConfig('change', stepId)
            //     }
            // }, 0);
            
        },
        changePage(tab) {
            this.$root.$refs.formGenerator.changeTab(tab)
        },
        addIdToSections (data, type){ 
            var sectionElements = document.getElementsByClassName("section-container")
            var elements = document.getElementsByClassName("headline-block") 
            var sectionIdArr = [], sectionObj = {}
            let configString = "<div style=\"display: inline-grid; grid-template-columns: 90px 90px 90px; grid-gap: 1px; border: 0.5px solid #A8A6A6; position:absolute; top:5%; left:63%; box-shadow: 1px 1px 5px 0.1px grey; background-color:white; cursor:pointer; z-index:100;\"><a id=\"editableSectionBtn\" style=\"display:block; padding: 5px; text-align:center; border-right:0.5px solid #A8A6A6; \" onmouseenter=\"this.style.background='#EFF3F8'\" onmouseout=\"this.style.background='#FFF'\">Editable</a><a id=\"read-onlySectionBtn\" style=\"display:block; padding: 5px; text-align:center; border-right:0.5px solid #A8A6A6;\" onmouseenter=\"this.style.background='#EFF3F8'\" onmouseout=\"this.style.background='#FFF'\">Read-only</a><a id=\"hiddenSectionBtn\" style=\"display:block; padding:5px; text-align:center;\" onmouseenter=\"this.style.background='#EFF3F8'\" onmouseout=\"this.style.background='#FFF'\">Hidden</a></div>"

            for(var key in this.formConfiguration.sections){
                sectionIdArr.push(key)
            }
            for(var i=0; i<sectionElements.length; i++){
                var el = sectionElements[i]
                el.setAttribute("id", sectionIdArr[i])                
            }
            for(let container of sectionElements) {
                container.onmouseenter = function() {
                    container.setAttribute("style", "background:#E9EDF580; padding-left:10px; padding-right:10px;")

                }
                container.onmouseleave = function() {
                    container.removeAttribute("style", "background")
                }
            }
            for(let section of elements){
                section.setAttribute("style", "position:relative;")
                let obj = {}, sectionContainer = section.parentElement.parentElement, sectionId = sectionContainer.id
                
                if(data !== null && data !== undefined && type !== "update"){
                    sectionObj = data 
                    if(data[sectionId].config === "ReadOnly"){
                        var controlInputElements = sectionContainer.getElementsByClassName("control-view")
                        for(let el of controlInputElements){
                            el.firstChild.nextSibling.setAttribute("disabled", "")
                        }
                    }
                    else if(data[sectionId].config === "Hidden") {
                        section.getElementsByTagName("h2")[0].setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 10%;")
                        var controlLabelElements = sectionContainer.getElementsByClassName("control-label-container")
                        for(let el of controlLabelElements){
                            el.getElementsByTagName("label")[0].setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 20%;")
                        } 
                    }
                }
                else if(data !== null && data !== undefined && type === "update"){
                    obj["sectionId"] = sectionId
                    obj["stepId"] = this.currentStep
                    obj["originalHtml"] = section.innerHTML
                    obj["html"] = section.innerHTML
                    obj["config"] = "Editable"

                    for(let item of data){
                        if(item.component===sectionId){
                            if(item.permission==="Hidden"){
                                section.getElementsByTagName("h2")[0].setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 10%;")
                                obj["html"] = section.innerHTML
                                var controlLabelElements = sectionContainer.getElementsByClassName("control-label-container")
                                for(let el of controlLabelElements){
                                    el.getElementsByTagName("label")[0].setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 20%;")
                                } 
                                obj["config"] = "Hidden"
                            }
                            else if(item.permission==="ReadOnly"){
                                var controlInputElements = sectionContainer.getElementsByClassName("control-view")
                                for(let el of controlInputElements){
                                    el.firstChild.nextSibling.setAttribute("disabled", "")
                                }
                                obj["config"] = "ReadOnly"
                            }
                        }
                    }
                    sectionObj[sectionId] = obj
                    this.stepHoverConfig[this.currentStep] = sectionObj
                }
                else {
                    obj["sectionId"] = sectionId
                    obj["stepId"] = this.currentStep
                    obj["originalHtml"] = section.innerHTML
                    obj["html"] = section.innerHTML
                    obj["config"] = "Editable"
                    obj["controls"] = {}
                    sectionObj[sectionId] = obj
                    this.stepHoverConfig[this.currentStep] = sectionObj
                }
                                

                let that = this
      
                section.onmouseenter = function() {
                    if(section.innerHTML.includes(configString)==false){
                        section.innerHTML += configString
                        document.getElementById("editableSectionBtn").addEventListener("click", function(){
                            sectionObj[sectionId]["config"] = "Editable"
                            section.getElementsByTagName("h2")[0].removeAttribute("style", "text-decoration")
                            sectionObj[sectionId]["html"] = sectionObj[sectionId]["originalHtml"]

                            var controlInputElements = sectionContainer.getElementsByClassName("control-view")
                            for(let el of controlInputElements){
                                el.firstChild.nextSibling.removeAttribute("disabled")
                            }

                            var controlLabelElements = sectionContainer.getElementsByClassName("control-label-container")
                            for(let el of controlLabelElements){
                                el.getElementsByTagName("label")[0].removeAttribute("style", "text-decoration")
                                
                                let controlId = el.getElementsByTagName("label")[0].htmlFor
                                sectionObj[sectionId].controls[controlId]["html"] = el.innerHTML
                                sectionObj[sectionId].controls[controlId]["label-html"] = el.innerHTML
                                sectionObj[sectionId].controls[controlId]["originalHtml"] = el.innerHTML
                            }
                            that.stepHoverConfig[that.currentStep] = sectionObj 
                        })
                        document.getElementById("read-onlySectionBtn").addEventListener("click", function(){
                            sectionObj[sectionId]["config"] = "ReadOnly"
                            section.getElementsByTagName("h2")[0].removeAttribute("style", "text-decoration")

                            var controlLabelElements = sectionContainer.getElementsByClassName("control-label-container")
                            for(let el of controlLabelElements){
                                el.getElementsByTagName("label")[0].removeAttribute("style", "text-decoration")
                            } 

                            var controlInputElements = sectionContainer.getElementsByClassName("control-view")
                            for(let el of controlInputElements){
                                el.firstChild.nextSibling.setAttribute("disabled", "")
                            
                                let controlId = el.firstChild.nextSibling.id
                                sectionObj[sectionId].controls[controlId]["html"] = el.firstChild.innerHTML
                                sectionObj[sectionId].controls[controlId]["label-html"] = el.firstChild.innerHTML
                                sectionObj[sectionId].controls[controlId]["originalHtml"] = el.firstChild.innerHTML
                            }
                            sectionObj[sectionId]["html"] = sectionObj[sectionId]["originalHtml"]
                            that.stepHoverConfig[that.currentStep] = sectionObj 
                            
                        })
                        document.getElementById("hiddenSectionBtn").addEventListener("click", function(){
                            sectionObj[sectionId]["config"] = "Hidden"

                            section.innerHTML = sectionObj[sectionId]["html"]
                            section.getElementsByTagName("h2")[0].setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 10%;")
                            sectionObj[sectionId]["html"] = section.innerHTML

                            var controlInputElements = sectionContainer.getElementsByClassName("control-view")
                            for(let el of controlInputElements){
                                el.firstChild.nextSibling.removeAttribute("disabled")
                                
                            }

                            var controlLabelElements = sectionContainer.getElementsByClassName("control-label-container")
                            for(let el of controlLabelElements){
                                el.getElementsByTagName("label")[0].setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 20%;")
                                
                                let controlId = el.getElementsByTagName("label")[0].htmlFor
                                sectionObj[sectionId].controls[controlId]["html"] = el.innerHTML
                                sectionObj[sectionId].controls[controlId]["label-html"] = el.innerHTML
                                sectionObj[sectionId].controls[controlId]["originalHtml"] = el.innerHTML
                            }                        
                            that.stepHoverConfig[that.currentStep] = sectionObj 
                            
                        })
                        
                    }
                }
                section.onmouseleave = function() {
                    section.innerHTML = sectionObj[sectionId]["html"]
                }
            }
            if(type==="update"){
                setTimeout(() => {
                    this.getControlElements(type, data);
                }, 0);
            }
            else{
                setTimeout(() => {
                    this.getControlElements();
                }, 0);
            }
        },
        getControlElements (type, data) {
            var sections = document.getElementsByClassName("section-container")
            
            for(let section of sections) {
                var elements = section.getElementsByClassName("control-label-container")
                let controlObj = {}, configString = "<div style=\"position:absolute; top:5%; left:30%; box-shadow: 1px 1px 5px 0.1px grey; background-color:white; cursor:pointer; z-index:100;\"><a id=\"editableBtn\" style=\"display:block; padding: 15px 50px 15px 15px;\" onmouseenter=\"this.style.background='#EFF3F8'\" onmouseout=\"this.style.background='#FFF'\">Editable</a><a id=\"read-onlyBtn\" style=\"display:block; padding: 10px 50px 15px 15px;\" onmouseenter=\"this.style.background='#EFF3F8'\" onmouseout=\"this.style.background='#FFF'\">Read-only</a><a id=\"hiddenBtn\" style=\"display:block; padding: 10px 50px 15px 15px;\" onmouseenter=\"this.style.background='#EFF3F8'\" onmouseout=\"this.style.background='#FFF'\">Hidden</a></div>"
    
                for(let item of elements) {
                    let obj = {}
                    let label = item.getElementsByTagName("label")[0]
                    let controlId = label.htmlFor
                    let controlInput = document.getElementById(controlId)
                    
                    if(type !== "update" && this.stepHoverConfig[this.currentStep][section.id]["controls"][controlId]){
                        controlObj = this.stepHoverConfig[this.currentStep][section.id]["controls"]
                        if(this.stepHoverConfig[this.currentStep][section.id]["controls"][controlId].config === "Hidden"){
                            var el = item.getElementsByTagName("label")[0]
                            el.setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 20%;")
                        }
                        else if(this.stepHoverConfig[this.currentStep][section.id]["controls"][controlId].config === "ReadOnly"){
                            var el = document.getElementById(controlId)
                            el.setAttribute("disabled", "")
                        }
                    }
                    else if(type === "update" && this.stepHoverConfig[this.currentStep][section.id]){
                        obj["controlId"] = controlId
                        obj["stepId"] = this.currentStep
                        obj["originalHtml"] = item.innerHTML
                        obj["html"] = item.innerHTML
                        obj["label-html"] = label.parentElement.innerHTML
                        obj["controlInput-html"] = controlInput

                        for(let perm of data){
                            
                            if(perm.component === controlId){
                                if(perm.permission === "Hidden"){
                                    var el = item.getElementsByTagName("label")[0]
                                    el.setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 20%;")
                                    obj["html"] = item.innerHTML
                                }
                                else if(perm.permission === "ReadOnly"){
                                    var el = document.getElementById(controlId)
                                    el.setAttribute("disabled", "")
                                }
                                obj["config"] = perm.permission
                            }
                            else{
                                obj["config"] = "Editable"
                            }
                        }
                        
                        controlObj[controlId] = obj
                        this.stepHoverConfig[this.currentStep][section.id]["controls"] = controlObj
                    }
                    else {
                        obj["controlId"] = controlId
                        obj["stepId"] = this.currentStep
                        obj["originalHtml"] = item.innerHTML
                        obj["html"] = item.innerHTML
                        obj["label-html"] = label.parentElement.innerHTML
                        obj["controlInput-html"] = controlInput
                        obj["config"] = "Editable"
                        controlObj[controlId] = obj
                        this.stepHoverConfig[this.currentStep][section.id]["controls"] = controlObj
                    }
                
                    let that = this

                    item.onmouseenter = function() {
                        if(item.innerHTML.includes(configString)==false){
                            item.innerHTML += configString
                            document.getElementById("editableBtn").addEventListener("click", function(){
                                controlObj[controlId]["config"] = "Editable"
                                
                                controlObj[controlId]['html'] = controlObj[controlId]['label-html']
                                // controlObj[controlId]["controlInput-html"].removeAttribute('disabled')
                                var control = document.getElementById(controlId)
                                control.removeAttribute("disabled")
                                var el = item.getElementsByTagName("label")[0]
                                el.removeAttribute("style", "text-decoration: line-through; text-decoration-thickness: 20%;")
                                that.stepHoverConfig[that.currentStep][section.id]["controls"] = controlObj
                            })
                            document.getElementById("read-onlyBtn").addEventListener("click", function(){
                                controlObj[controlId]["config"] = "ReadOnly"
                            
                                item.innerHTML = controlObj[controlId]['html']
                                // controlObj[controlId]["controlInput-html"].setAttribute("disabled", "")
                                var control = document.getElementById(controlId)
                                control.setAttribute("disabled", "")
                                var el = item.getElementsByTagName("label")[0]
                                el.removeAttribute("style", "text-decoration: line-through; text-decoration-thickness: 20%;")
                                that.stepHoverConfig[that.currentStep][section.id]["controls"] = controlObj
                            })
                            document.getElementById("hiddenBtn").addEventListener("click", function(){
                                var control = document.getElementById(controlId)
                                control.removeAttribute("disabled")
                                controlObj[controlId]["config"] = "Hidden"

                                item.innerHTML = controlObj[controlId]["html"]
                                var el = item.getElementsByTagName("label")[0]
                                el.setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 20%;")
                                controlObj[controlId]["html"] = item.innerHTML
                                that.stepHoverConfig[that.currentStep][section.id]["controls"] = controlObj                                
                            })
                            
                        }
                        
                        
                    }
                    item.onmouseleave = function() {
                        item.innerHTML = controlObj[controlId]['html']
                    }
                    
                }
            
            }
        },
        addTableConfig(type, step) {
            var tableHeader = document.getElementById('formTableHeader')
            var table = document.getElementsByClassName('component-content')[0]
            var rows = document.getElementById("systable").getElementsByTagName("tbody")[0].getElementsByTagName("tr")

            //clear styles
            tableHeader.removeAttribute("style", "text-decoration: line-through; text-decoration-thickness: 10%;")
            table.removeAttribute("style", "filter: opacity(60%);")
            for(let item of rows){
                var td = item.getElementsByTagName("td")
                for(let cell of td) {
                    cell.setAttribute("style", "background: #fff;")
                }
            }

            //add styles
            if(type === 'Hidden') {
                tableHeader.setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 10%;")
                table.setAttribute("style", "filter: opacity(60%);")
                this.stepTableConfig[step] = 'Hidden'
            }
            else if(type === 'ReadOnly'){
                for(let item of rows){
                    var td = item.getElementsByTagName("td")
                    for(let cell of td) {
                        cell.setAttribute("style", "background: #e9ecef;")
                    }
                }
                this.stepTableConfig[step] = 'ReadOnly'
            }
            else if(type === 'Editable') {
                this.stepTableConfig[step] = 'Editable'
            } 
            else {
                //update styles when step changes
                if(this.stepTableConfig[step] === 'Editable') {
                    this.addTableConfig('Editable', step)
                }
                else if(this.stepTableConfig[step] === 'Hidden') {
                    this.addTableConfig('Hidden', step)
                }
                else if(this.stepTableConfig[step] === 'ReadOnly') {
                    this.addTableConfig('ReadOnly', step)
                }
            }
        },
        addFileConfig(type, step) {
            var fileInput = document.getElementsByClassName("custom-file")[0]
            var fileHeader = document.getElementById("fileInputHeader")

            fileInput.removeAttribute("style", "filter: opacity(60%);")
            this.btnDisabled = false
            fileHeader.removeAttribute("style", "text-decoration: line-through; text-decoration-thickness: 10%;")

            if(type === 'Editable'){
                this.stepFileConfig[step] = 'Editable'
            }
            else if(type === 'ReadOnly'){
                this.stepFileConfig[step] = 'ReadOnly'
                this.btnDisabled = true
            }
            else if(type === 'Hidden'){
                fileHeader.setAttribute("style", "text-decoration: line-through; text-decoration-thickness: 10%;")
                fileInput.setAttribute("style", "filter: opacity(60%);")
                this.stepFileConfig[step] = 'Hidden'
            }
            else {
                //update styles when step changes
                if(this.stepFileConfig[step] === 'Editable') {
                    this.addFileConfig('Editable', step)
                }
                else if(this.stepFileConfig[step] === 'Hidden') {
                    this.addFileConfig('Hidden', step)
                }
                else if(this.stepFileConfig[step] === 'ReadOnly') {
                    this.addFileConfig('ReadOnly', step)
                }
            }
        },
        changeButtonHoverConfig (stepId, buttonId, type) {
            this.showActionButtons = false
            this.buttonConfig[stepId][buttonId] = type
            this.showActionButtons = true
        },
        sendFormData () {
            let permissionsConfig = {}
        
            for(let key in this.stepHoverConfig){
                let item = this.stepHoverConfig[key]
                let array = []
                for(let section in item){
                    if(item[section]["config"] !== "Editable"){
                        let obj = {}
                        var uuid = 'permission_' + uuidv4()

                        obj.id = uuid
                        obj.permission = item[section]["config"]
                        obj.component = section
                        array.push(obj)
                        permissionsConfig[key] = array
                    }
                    else{
                        for(let control in item[section]["controls"]){
                            if(item[section]["controls"][control]["config"] !== "Editable"){
                                let obj = {}
                                var uuid = 'permission_' + uuidv4()

                                obj.id = uuid
                                obj.permission = item[section]["controls"][control]["config"]
                                obj.component = control
                                array.push(obj)
                                permissionsConfig[key] = array
                            }
                        }
                    }
                }
                
            }

            let tableObj = {}
            if(this.isTableAdded) {
                tableObj.tableName = this.tableName
                tableObj.tablePermissions = this.stepTableConfig
                tableObj.tableData = this.tableData
            }

            let fileObj = {}
            if(this.isFileAdded) {
                fileObj.filePermissions = this.stepFileConfig
            }

            let permissionData = {
                "permissions" : permissionsConfig,
                "buttonConfig" : this.buttonConfig,
                "tableObject" : tableObj,
                "fileObject" : fileObj
            }
            if(this.isUpdateMode == true) {
                this.$emit("updateForm",permissionData)
            }
            else{
                this.$emit("permissions",permissionData)
            }
        },
        cancel() {
            this.$emit("cancel")
        },
        checkPermissions(){
            if(this.isUpdateMode == true){
                this.changeStep("start")
                if(Object.keys(this.tablePermissions).length !== 0){
                    this.stepTableConfig = this.tablePermissions
                    setTimeout(() => {
                        this.addTableConfig('change', 'start');
                    }, 10);
                }
                if(Object.keys(this.filePermissions).length !== 0){
                    this.stepFileConfig = this.filePermissions 
                    setTimeout(() => {
                        this.addFileConfig('change', 'start');
                    }, 10);
                }

            }
            else{
               setTimeout(() => {
                    this.addIdToSections();
                }, 10);
            }
            
        },
        fillTempConfigs() {
            const configuration =  Object.assign({}, this.formConfiguration);
            const controls = configuration.controls
            const sections = configuration.sections

            let tempControlConfigObj = {}, tempSectionConfigObj = {}
            for(let key in controls) {
                tempControlConfigObj[key] = controls[key].permission
            }

            for(let key in sections) {
                tempSectionConfigObj[key] = sections[key].permission
            }

            this.tempControlConfig = tempControlConfigObj
            this.tempSectionConfig = tempSectionConfigObj
         
        }
        
    },
    mounted() {
        let obj = {permissions : this.formPermissions, buttonConfig: this.buttonConfig}
        this.concat_data = {...this.formConfiguration, ...this.flow, ...obj}

        for(let item of this.flow['sequence']){
            let stepObj = {}
            stepObj.stepId = item
            this.formConfigData.push(stepObj)
        }
        if(Object.keys(this.buttonConfig).length===0){
            for(let key in this.flow.steps){
                this.buttonConfig[key] = {
                    "sendBack" : "show",
                    "reject" : "show"
                }
            }
        }

        if(this.isUpdateMode) {
            this.fillTempConfigs()
        }
    },
}
</script>

<style scoped>
    .pageFooter {
        display: flex;
        background: #fff;
        color: #333333CC;
        position: fixed;
        width: 100%;
        bottom: 0%;
        height: 70px;
        align-items: center;
        left: 0;
        border-top: 1px solid rgba(139, 146, 158, 0.5);
        z-index: 99;
    }
    .currentStep {
        margin-bottom: 1rem;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        
    }
    .currentStep .active {
        background: #009FF7;
        color: #FFFFFF;
    }
    .stepBtn {
        background: #FFFFFF;
        color: #333333;
        padding:0.75rem;
        border-radius: 4px;
        cursor: pointer;
    }
    .fitContent {
        display: block;
        width: 100%;
    }
    .formSection {
        position: relative;
        display: flex;
        flex-direction: column;
        background: #FFFFFF;
        padding: 30px 10px;
        border-radius: 4px;
        min-height: 750px;
    }
    .actionButtons {
        display: flex;
        flex-direction: column;
        height: 100%;
        /* align-items: end; */
        justify-content: end;
        padding: 25px 16px 10px 16px;
    }
    .btn {
        min-width: 120px;
    }
    .btnLight {
        background: #E9EDF5;
        color: #333333CC;
        font-weight: 500;
    }

    .sendBackHover {
        display: none;
        
    }
    .actionBtn:hover > .sendBackHover {
        position: absolute;
        display: flex;
        margin-left: 11px;
    }
    .actionBtn:hover > .btnLight{
        background:  rgba(0, 0, 0, 0.8);
        color: black;
        border-color: rgba(0, 0, 0, 0.8);
    }
    .sendBackHover > button {
        background: white;
        padding: 10px;
        min-width: 50px;
        border: none;
        border-radius: 0px;
        font-weight: 500;
        outline: none;
    }
    .sendBackHover .active {
        background: #1991EB;
        color: white;
        outline: none;
    }
    .cancelBtn:hover {
        background: #dddddd;
    }
    .separator{
        display: flex;
        align-items: center;
    }
    .separator span{
        padding: 0 1rem; /* creates the space */
    }
    .separator .line{
        flex: 1;
        height: 1px;
        background-color: #000;
    }
    .table-section {
        position: relative;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .table-section:hover {
        background-color: #E9EDF580;
        padding-right: 10px;
        padding-left: 10px;
    }
    .tableConfigButtons {
        display: none;        
    }
    .table-section:hover > .tableConfigButtons {
        display: inline-grid; 
        grid-template-columns: 90px 90px 90px; 
        grid-gap: 1px; 
        border: 0.5px solid #A8A6A6; 
        position:absolute; 
        top:5%; 
        left:63%; 
        box-shadow: 1px 1px 5px 0.1px grey; 
        background-color:white; 
        cursor:pointer; 
        z-index:100;
    }
    .tableConfigButtons > a {
        display:block; 
        padding: 5px; 
        text-align:center; 
        border-right:0.5px solid #A8A6A6;
    }
    .tableConfigButtons > a:hover {
        background-color: #EFF3F8;
    }
    .scrollable {
        box-sizing: border-box;
        height: 80vh;
        overflow-y: scroll;
        background-color: #FFFFFF;
        border-radius: 4px;
    }
    /* Hide scrollbar for Chrome, Safari and Opera */
    .scrollable::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    .scrollable {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }

    .custom-file-label{
        padding-left:80px;
        color: #D1D1D7;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        overflow: hidden;
    }
    .custom-file-label::after{
        left: 0;
        right: auto;
        content: "Göz At";
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        background-color: #3767a0 !important;
        cursor: pointer !important;
        color: #fff !important;
    }

</style>